export const ANALYZE_CART_PAGE_VIEW = 'ANALYZE_CART_PAGE_VIEW';
export const ANALYZE_ITEM_CLICK = 'ANALYZE_ITEM_CLICK';
export const ANALYZE_ITEM_QUANTITY_CHANGE = 'ANALYZE_ITEM_QUANTITY_CHANGE';
export const ANALYZE_CLEAR_CART = 'ANALYZE_CLEAR_CART';
